
export const ValidateInvDocInput = (shipDoc, _createErrorMessage) => {
  if (!shipDoc) {
    _createErrorMessage("81");
    return false;
  }

  return true;
};
